import { bsc, hardhat, mainnet } from 'wagmi/chains';

export const FORGE_TAB = 'From Forge';
export const WALLET_TAB = 'From Wallet';
export const DYDX_REDEEM_TAB = [
  {
    title: FORGE_TAB,
    isWallet: false,
  },
  {
    title: WALLET_TAB,
    isWallet: true,
  },
];

export enum TOKEN_COLORS {
  USDC = '#274CEC',
  WBTC = '#F6911E',
  WETH = '#808080',
  BTCB = '#F8A139',
  WBNB = '#F0B90B',
  BUSD = '#F9D53B',
  ADA = '#0133AE',
  XRP = '#828384',
  MATIC = '#8247E5',
  ETH = '#343535',
  BETH = '#343535',
  SOL = '#21EBAC',
  AVAX = '#E84142',
  DOT = '#E6007A',
}

export enum DynasetSymbol {
  'dynSING' = 'dynSING',
  'dynBTC' = 'dynBTC',
  'dynETH' = 'dynETH',
  'dynDYDX' = 'dynDYDX',
  'dynL1BNB' = 'dynL1BNB',
  'dynETHc' = 'dynETHc',
}

export const InsurableDynasets = [DynasetSymbol.dynBTC, DynasetSymbol.dynETH];

export const DynasetNetworkMap = {
  [DynasetSymbol.dynL1BNB]: bsc.id,
  [DynasetSymbol.dynDYDX]: mainnet.id,
  [DynasetSymbol.dynSING]: mainnet.id,
  [DynasetSymbol.dynBTC]: mainnet.id,
  [DynasetSymbol.dynETH]: mainnet.id,
  [DynasetSymbol.dynETHc]: mainnet.id,
};

const chainIdListType1 = [mainnet.id, hardhat.id];

const chainIdListType3 = [
  bsc.id,
  hardhat.id,
  31339, // bsc-hardhat-fork
];

export const DynasetChainIdList = {
  [DynasetSymbol.dynL1BNB]: chainIdListType3,
  [DynasetSymbol.dynDYDX]: chainIdListType1,
  [DynasetSymbol.dynSING]: chainIdListType1,
  [DynasetSymbol.dynBTC]: chainIdListType1,
  [DynasetSymbol.dynETH]: chainIdListType1,
  [DynasetSymbol.dynETHc]: chainIdListType1,
};
